import { useEffect, useState } from 'react';

export const useScale = (ref: React.RefObject<Element>, width: number, height: number) => {
    const [scale, setScale] = useState<number>(1);

    const refreshData = () => {
        const wrapper = ref.current;
        if (wrapper) {
            const availableWidth = wrapper.clientWidth;
            const availableHeight = wrapper.clientHeight;
            const s = Math.min(availableWidth / width, availableHeight / height);
            setScale(s);
        }
    };

    useEffect(() => {
        refreshData();
        window.addEventListener('resize', refreshData);

        return () => {
            window.removeEventListener('resize', refreshData);
        };
    });

    return scale;
};
